module.exports = __webpack_public_path__ + "img/pistarlab_agent_training1.595fdba0.png";